import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { TypedUseSelectorHook } from "react-redux";
import snackbarReducer from "./slices/snackbarSlice";
import loaderReducer from "./slices/loaderSlice";
import authReducer from "./slices/authSlice";
import productsReducer from "./slices/productsSlice";
import createorderReducer from "./slices/createOrdersSlice";
import categoryReducer from "./slices/categorySlice";
import subCategoryReducer from "./slices/subCategorySlice";
import OrderHistoryReducer from "./slices/OrderHistorySlice";
import shippingsReducer from "./slices/shippingsSlice";
import invoicesReducer from "./slices/invoicesSlice";
import languageReducer from "./slices/languagesSlice";
import profileReducer from "./slices/ProfileUpdateSlice";
import draftorderReducer from "./slices/draftOrdersSlice";
import supplierReducer from "./slices/supplierSlice";
import storeReducer from "./slices/storeSlice";
import userProfileReducer from "./slices/GetUserProfileSlice";
import suppliersReducer from "./slices/GetsuppliersSlice";
import messagesReducer from "./slices/messagesSlice";
import taxesReducer from './slices/taxesSlice';
import countryReducer from './slices/countriesSlice';
import statesReducer from './slices/statesSlice';
import shippingMethodsReducer from './slices/shippingMethodsSlice';

export const store = configureStore({
	reducer: {
		loader: loaderReducer,
		snackbar: snackbarReducer,
		auth: authReducer,
		products: productsReducer,
		createorder: createorderReducer,
		draftorder: draftorderReducer,
		category: categoryReducer,
		subCategory: subCategoryReducer,
		OrderHistory: OrderHistoryReducer,
		shippings: shippingsReducer,
		invoices: invoicesReducer,
		messages: messagesReducer,
		languages: languageReducer,
		profile: profileReducer,
		supplier: supplierReducer,
		store: storeReducer,
		userProfile: userProfileReducer,
		suppliers: suppliersReducer,
		taxes: taxesReducer,
		country: countryReducer,
		states: statesReducer,
		shippingMethods: shippingMethodsReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore these action types
				ignoredActions: ["your/action/type"],
				// Ignore these field paths in all actions
				ignoredActionPaths: ["payload"],
				// Ignore these paths in the state
				ignoredPaths: ["items.dates"],
			},
		}),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
